import Handlebars from "../handlebars/handlebars";
import confirmHtml from "./confirm.hbs"

const CONFIRM_ACTION = '.js-action--confirm' ;
const CANCEL_ACTION = '.js-action--cancel';
const DEFAULT_LABEL = 'Confirm';
class ConfirmController {
    constructor (modalInstance, container, buttonLabel, onConfirm = () => {}, onConfirmError = () => {}) {
        this.state = {
            label: buttonLabel || DEFAULT_LABEL,
            loading: false
        };

        this.modalInstance = modalInstance;
        this.container = container;
        this.template = confirmHtml;
        this.onConfirm = onConfirm;
        this.onConfirmError = onConfirmError;

        this.handleClick = this.handleClick.bind(this);

        this.enableUI()
        this.render()
    }

    enableUI () {
        this.container.addEventListener('click', this.handleClick, false);
    }

    render () {
        this.container.innerHTML = this.template(this.state);
    }

    async handleClick (e) {
        if (e.target.matches(CONFIRM_ACTION)) {
            e.preventDefault();
            this.enableLoadingState();
            try {
                const result = await this.onConfirm();
                this.modalInstance.close(result);
            } catch (error) {
                this.onConfirmError(error);
            } finally {
                this.disableLoadingState();
                return;
            }
        }

        if (e.target.matches(CANCEL_ACTION)) {
            e.preventDefault();
            this.modalInstance.cancel();
            return;
        }
    }

    enableLoadingState () {
        this.state.loading = true;
        this.render();
    }

    disableLoadingState () {
        this.state.loading = false;
        this.render();
    }

}
export default ConfirmController;